<template>
  <div class="drawer" style="height: calc(100vh - 60px);">
    <div v-show="isHistoryShow" class="drawer-meng" @click="isHistoryShow = false"></div>
    <CommonSearch
      ref="CommonSearch"
      style="border-bottom:none"
      :search-label="searchLabel"
      :show-history-dialog="isHistoryShow"
      @showHistory="isHistoryShow = true"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    >
    </CommonSearch>
    <div v-if="company&&company._id" class="drawer-result">
      <div class="drawer-box">
        <div class="drawer-newsalary-title">
          <div style="display:inline-block">
            <i class="el-icon-office-building breadcrumb-icon" style="color:#669999"></i>
            <span style="color:#262626;font-weight:600;">公司薪酬职级</span>
          </div>
          <span class="svg-text-btn" style="color:#669999" @click="changeSearchType('行业薪酬')">
            <svg t="1621844337690" fill="#669999" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11003" width="12" height="12"><path d="M490.666667 117.333333a32 32 0 0 1 3.072 63.850667L490.666667 181.333333H192a10.666667 10.666667 0 0 0-10.496 8.746667L181.333333 192v640a10.666667 10.666667 0 0 0 8.746667 10.496L192 842.666667h640a10.666667 10.666667 0 0 0 10.496-8.746667L842.666667 832V533.333333a32 32 0 0 1 63.850666-3.072L906.666667 533.333333v298.666667a74.666667 74.666667 0 0 1-70.570667 74.56L832 906.666667H192a74.666667 74.666667 0 0 1-74.56-70.570667L117.333333 832V192a74.666667 74.666667 0 0 1 70.570667-74.56L192 117.333333h298.666667z m341.333333 0a74.666667 74.666667 0 0 1 74.56 70.570667L906.666667 192v128a32 32 0 0 1-63.850667 3.072L842.666667 320v-77.226667A781.781333 781.781333 0 0 0 455.168 627.2a32 32 0 1 1-58.112-26.816A845.738667 845.738667 0 0 1 823.296 181.333333H704a32 32 0 0 1-3.072-63.850666L704 117.333333h128z" p-id="11004"></path></svg>
            行业薪酬
          </span>
        </div>
        <div class="type-change-box">
          <span
            :class="`search_tab_item ${activeType==='公司薪酬职级'?'tab_item_selected':'tab_item_default'}`"
            @click="activeType = '公司薪酬职级'"
            >公司薪酬职级</span
          >
          <span
            :class="`search_tab_item ${activeType==='公司已有人员薪酬'?'tab_item_selected':'tab_item_default'}`"
            @click="activeType = '公司已有人员薪酬'"
            >公司已有人员薪酬</span
          >
        </div>
        <div v-if="activeType === '公司薪酬职级'">
          <Salary ref="Salary" :company="company"></Salary>
        </div>
        <div v-else>
          <div v-for="(radish, k) in radishData" :key="k"
            style="padding:10px;border:1px solid #ccc;border-radius:4px;margin-bottom:10px">
            <div style="display:flex;margin-bottom:5px">
              <div class="radish-link" style="margin-right:10px;word-break: keep-all;flex: none;" @click="showRadish(radish._id)">{{name(radish.姓名)}}</div>
              <div style="flex: auto;">
                <template v-if="company.简称 && radish.职能模块 && radish.职能模块.length > 0">
                  <el-tag v-for="zhi in radish.职能模块" :key="zhi" size="mini" style="margin-right:5px;margin-bottom:5px">{{zhi}}</el-tag>
                </template>
                <template v-if="radish.职级">
                  <el-tag style="margin-right:5px;margin-bottom:5px" size="mini">{{zhiMap[radish.职级]}}</el-tag>
                </template>
                <template v-if="radish.专业职级">
                  <el-tag style="margin-right:5px;margin-bottom:5px" size="mini">{{radish.专业职级}}</el-tag>
                </template>
              </div>
            </div>
            <div style="display:flex;justify-content:space-around;flex-wrap: wrap;">
              <div style="width: 50%;">月固薪(万): {{money(radish.月固薪)}}</div>
              <div style="width: 50%;">年固薪(万): {{money(radish.年固薪)}}</div>
              <div style="width: 50%;">奖金(万): {{money(radish.奖金)}}</div>
              <div style="width: 50%;">全薪(万): {{money(radish.全薪)}}</div>
            </div>
          </div>
          <div v-if="showMore" style="text-align:center;margin-botton:10px">
            <el-button type="text" @click="next">加载更多</el-button>
          </div>
        </div>
      </div>
      <div class="edit-btn-box">
        <el-button size="mini" @click="toCompany">编辑</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import CommonSearch from '../../searchBar/CommonSearch'
import { searchLabel2Value, searchPlaceHolder } from '../../constant/utils'
import Salary from '../company/NewSalary'

const searchLabel = '薪酬'
export default {
  components: { CommonSearch, Salary },
  data: function() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
      placeHolder: searchPlaceHolder[searchLabel],
      keywords: '',
      result: [],
      isHistoryShow: false,
      company:{},
      activeType:'公司薪酬职级',
      radishData:[],
      page: 1,
      limit: 300,
      showMore: false,
      zhiMap: {
        '1': '1.高管',
        '2': '2.部门总',
        '3': '3.部门副总/总助/团队长',
        '4': '4.部门核心骨干',
        '5': '5.新人三年以下',
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.keywords = ''
      this.result = []
    },
    goBack() {
      this.$emit('goBack')
    },
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    toCompany() {
      window.open(
        `${window.origin}#/company/${this.company._id}?activeTab=CompanySalary&isEdit=true`,
      )
    },
    setSearchHistory() {
      this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
      if (!this.searchHistory[this.searchType]) this.searchHistory[this.searchType] = []
      if (!this.searchHistory[this.searchType].includes(this.keywords)) {
        this.searchHistory[this.searchType].unshift(this.keywords)
        localStorage.searchHistory = JSON.stringify(this.searchHistory)
      }
    },
    async doSearch() {
      if (!this.keywords) return this.$message.info('请输入搜索内容')
      this.setSearchHistory()
      this.isHistoryShow = false
      // this.checkSelect()
      try {
        await app.service('misc').insertSearchHistory({ type: searchLabel, keywords: this.keywords })
      } catch (e) {}
      const res = await app.service('company').getCompany(this.keywords)
      if (res.status === 200) {
        this.company = res.result
        this.page = 1
        this.limit = 300
        this.radishData = []
        this.getRadishMoney()
      } else this.$message.error('请输入正确的简称重新查询')
    },
    async getRadishMoney(){
      if (!this.company.简称) {
        this.radishData = []
        return false
      }
      const query = {}
      if (this.company.简称) query.公司 = this.company.简称
      const res = await app.service('radish').getRadishesMoney({query, limit: this.limit, skip: this.limit*(this.page - 1)})
      // console.log(query,this.page, res)
      if (res.status == 'success') {
        if (res.data.length == 0) {
          this.showMore = false
        } else {
          const radishData = res.data.filter(dt=>!((!dt.月固薪 || isNaN(dt.月固薪)) && (!dt.年固薪 || isNaN(dt.年固薪)) && (!dt.奖金 || isNaN(dt.奖金)) && (!dt.全薪 || isNaN(dt.全薪))))
          if (this.page > 1) {
            this.radishData = this.radishData.concat(radishData)
          } else {
            this.radishData = radishData
          }
          this.showMore = true
        }
      }
    },
    next() {
      this.page = this.page + 1
      this.getRadishMoney()
    },
    name(n) {
      return `${n.substr(0, 1)}**`
    },
    money(m) {
      if (!m || isNaN(m)) return '--'
      return m
    },
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    defaultSearch({ type, keywords, result }) {
      this.searchType = type
      this.keywords = keywords
      this.$refs.CommonSearch.keywords = keywords
      if (result) {
        this.result = result
      } else {
        this.$nextTick(() => {
          this.doSearch()
        })
      }
    },
  },
}
</script>
<style scoped>
.drawer-newsalary-title{
  display: flex;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
}
.type-change-box{
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
}
.drawer-newsalary-title i{
  font-size: 16px;
}
.svg-text-btn{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.search_tab_item {
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 0 0;
  padding: 4px 12px;
  border-radius: 2px;
  min-width: 76px;
  text-align: center;
  color:#fff;
}
.search_tab_item.tab_item_selected {
  background-color:#669999;
}
.search_tab_item.tab_item_default{
  background-color: #2478b5;
}
.edit-btn-box {
  display: flex;
  padding: 0 10px 10px;
  justify-content: flex-end;
}
</style>
